import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Form, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';

import { JOB_RUNS } from 'lib/networking/endpoints';
import usePost from 'lib/hooks/usePost';

function RunJobModal({ job, onHide, refetch }) {
  const [paramsText, setParamsText] = useState(JSON.stringify(job.default_params || {}, null, 2));
  const [paramsError, setParamsError] = useState(null);

  const { postData: triggerRun, loading } = usePost(
    JOB_RUNS(job.id),
    () => {
      Swal.fire({
        title: 'Run Triggered',
        text: `Job "${job.name}" has been queued.`,
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        refetch();
        onHide();
      });
    },
    () => {
      Swal.fire({
        title: 'Error',
        text: 'Failed to trigger the job run. Please try again.',
        icon: 'error',
      });
    },
  );

  const handleRun = () => {
    let params = {};
    try {
      params = JSON.parse(paramsText || '{}');
    } catch {
      setParamsError('Invalid JSON — please check your parameters.');
      return;
    }
    setParamsError(null);
    triggerRun({ params });
  };

  return (
    <Modal show onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Run Job: {job.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label className="font-weight-bold">Target</Form.Label>
          <Form.Control
            as="textarea"
            rows={1}
            readOnly
            value={`${job.module_name}.${job.class_name}.${job.method}`}
            className="text-muted"
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="font-weight-bold">Parameters (JSON)</Form.Label>
          <Form.Control
            as="textarea"
            rows={6}
            value={paramsText}
            onChange={e => setParamsText(e.target.value)}
            isInvalid={!!paramsError}
          />
          {paramsError && (
            <Form.Control.Feedback type="invalid">{paramsError}</Form.Control.Feedback>
          )}
          <Form.Text className="text-muted">
            Override default parameters. Leave as-is to use the defaults.
          </Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleRun} disabled={loading}>
          {loading ? 'Triggering…' : 'Run'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

RunJobModal.propTypes = {
  job: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    module_name: PropTypes.string,
    class_name: PropTypes.string,
    method: PropTypes.string,
    default_params: PropTypes.object,
  }).isRequired,
  onHide: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default RunJobModal;
